import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";
import className from "../style.module.scss";
import Incorrect_Icon from "@common/images/incorrect-icon-light.svg";

export function Tooltip(props) {
  return (
    <span
      className={className.tooltipContainer}
      style={{
        bottom: !props.tooltipDirection.includes("bottom")
          ? "calc(100% + 20px)"
          : null,
        top: props.tooltipDirection.includes("bottom")
          ? "calc(100% + 20px)"
          : null,
        right: props.tooltipDirection.includes("left") ? "0px" : null,
        left: props.tooltipDirection.includes("right") ? "0px" : null,
      }}
    >
      {/* Translations support needed */}
      <span className={className.tooltipContent}>
        <FormattedMessage
          string={props.text}
          sanitizeConfig={sanitizeConfigOptions.LightInlineText}
          description=""
        />
        {props.isIncorrectDropdown &&
          (props.offerReset ? (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.changeState(props.id, props.changeStateTo);
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <img
                alt={FormattedMessage({
                  string: "Incorrect. Clear or reset selection",
                })}
                src={Incorrect_Icon}
              />
            </button>
          ) : (
            <img
              alt={FormattedMessage({ string: "Incorrect" })}
              src={Incorrect_Icon}
              style={{
                cursor: "inherit",
                borderColor: "transparent",
              }}
            />
          ))}
      </span>
      <span
        className={className.tooltipBeakContainer}
        style={{
          justifyContent: props.tooltipDirection.includes("left")
            ? "right"
            : props.tooltipDirection.includes("right")
              ? "left"
              : "center",
          top: props.tooltipDirection.includes("bottom") ? "-6px" : null,
        }}
      >
        <span
          className={className.tooltipBeak}
          style={{
            marginTop: !props.tooltipDirection.includes("bottom")
              ? "-15px"
              : null,
            marginRight: props.tooltipDirection.includes("left") ? "7px" : null,
            marginLeft: props.tooltipDirection.includes("right") ? "7px" : null,
          }}
        ></span>
      </span>
    </span>
  );
}

Tooltip.propTypes = {
  tooltipDirection: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
